module.exports = __webpack_public_path__ + "static/media/029.100a1e56.jpg";